<div *ngIf="savedSearchesService.savedSearches$ | async as savedSearches" class="pcg-saved-searches-page container">
    <div *ngIf="savedSearches.length" class="pcg-saved-searches-page__grid">
        <div *ngFor="let savedSearch of savedSearches" class="pcg-saved-searches-page__item">
            <pcg-ng-saved-search-card [savedSearch]="savedSearch">
            </pcg-ng-saved-search-card>
        </div>
    </div>

    <div *ngIf="!savedSearches.length" class="pcg-saved-searches-no-results">
        <div class="pcg-saved-searches-no-results__image pcg-contrast__bg-extra pcg-contrast__color-main"></div>
        <h2 class="pcg-saved-searches-no-results__title">No saved searches</h2>
        <p class="pcg-saved-searches-no-results__text pcg-contrast__color-main">You don't have any saved searches yet</p>
    </div>
</div>
